import React from 'react'

const CapIcon = () => {
  return (
    <div>
<svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20.375 11.375V6.5L11 1.625L1.625 6.5L11 11.375L15.875 9.125V14.375C15.875 15.875 13.625 17.375 11 17.375C8.375 17.375 6.125 15.875 6.125 14.375V9.125" stroke="#CCCFD6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

    </div>
  )
}

export default CapIcon
